import { MotifButton,MotifIcon } from '@ey-xd/motif-react'
import { IconoirPlus } from "@ey-xd/motif-icon";
import React from 'react'
import { useDispatch } from 'react-redux'
import { openClientCard } from '../../features/Client/clientCardSlice'
import { useMsal } from '@azure/msal-react';

import styles from './index.module.scss'

export const Breadcrumbs: React.FC = () => {
  const dispatch = useDispatch()
  const { instance } = useMsal()
  const activeAccount = instance.getActiveAccount()
  const accountName = activeAccount?.name

  return (
    <div className={styles.breadcrumbs}>
      <div className="motif-container">
        <div className="motif-row justify-content-between align-items-center">
          <div className="motif-col-xs-9 motif-col-sm-8 motif-col-md-9 motif-col-lg-9">

            <div className={styles.greeting}>Welcome {accountName} !</div>
            <div className={styles.message}>
              Welcome to the SOD Tool Engagement Dashboard, your centralized platform for assessing segregation of duties 
              between users with access to develop and implement within your engagements.
            </div>
          </div>
          <div className="motif-col-xs-3 motif-col-md-3 motif-col-lg-3 pullRight">
            <div>
              <MotifButton
                size="small"
                type="submit"
                variant="primary-alt"
                onClick={() => {
                  dispatch(openClientCard(null))
                }}
              >
                <MotifIcon iconFunction={IconoirPlus} title="Create new engagement" />
                Create new client engagement
              </MotifButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
